// extracted by mini-css-extract-plugin
module.exports = {"modal":"Qr92ZGW8","content":"_Pwe69Uc","qrcode":"xI1UpMEf","title":"MqBQD7hg","description":"a9lnDVjZ"};